import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

import {GameCanvasWrapper, TeamvineProvider} from '@glark-newco/game-library';
import {createTheme, defaultVariantColorsResolver, VariantColorsResolver} from '@mantine/core';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {SupplyChainOverlaySupplier} from './components/SupplyChainOverlaySupplier';
import {SupplyChainProjections} from './state/SupplyChainProjections';
import {SupplyChainCanvas} from './SupplyChainCanvas';

const variantColorResolver: VariantColorsResolver = (input) => {
    // See https://mantine.dev/styles/variants-sizes/#variantcolorresolver.
    // More flexible: https://mantine.dev/styles/variants-sizes/#custom-variants-types

    // Custom variant for "global" controls - e.g. VolumeButton and FullScreenButton
    if (input.variant === 'global') {
        return {
            background: 'var(--mantine-color-blue-6)',
            hover: 'var(--mantine-color-blue-4)',
            color: 'var(--mantine-color-white)',
            border: '0.15em solid white',
        };
    }
    return defaultVariantColorsResolver(input);
};

createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
        <TeamvineProvider gameType={'SupplyChain'}
            theme={createTheme({
                fontFamily:'Roboto Variable, emoji, sans-serif',
                headings: {fontFamily: 'Roboto Variable, sans-serif'},
                variantColorResolver,
            })}>
            <SupplyChainProjections/>
            <GameCanvasWrapper gameName={'Supply Chain'} gameType={'SupplyChain'} overlaySupplier={SupplyChainOverlaySupplier}>
                <SupplyChainCanvas/>
            </GameCanvasWrapper>
        </TeamvineProvider>
    </StrictMode>,
);
